import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-place": "true",
  "data-kt-place-mode": "prepend",
  "data-kt-place-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
}
const _hoisted_2 = {
  class: "menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 ms-13 my-lg-0 align-items-stretch",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_4 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" }
const _hoisted_5 = { class: "menu-item" }
const _hoisted_6 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/utilities"
}
const _hoisted_7 = { class: "menu-icon" }
const _hoisted_8 = {
  key: 0,
  class: "bi bi-box fs-3"
}
const _hoisted_9 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_10 = { class: "menu-title" }
const _hoisted_11 = { class: "menu-item" }
const _hoisted_12 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/doc-overview"
}
const _hoisted_13 = { class: "menu-icon" }
const _hoisted_14 = {
  key: 0,
  class: "bi bi-card-text fs-3"
}
const _hoisted_15 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_16 = { class: "menu-title" }
const _hoisted_17 = { class: "menu-item" }
const _hoisted_18 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/changelog"
}
const _hoisted_19 = { class: "menu-icon" }
const _hoisted_20 = {
  key: 0,
  class: "bi bi-journal-code fs-3"
}
const _hoisted_21 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_24 = {
  class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown w-100 w-lg-600px p-5 p-lg-5",
  style: {}
}
const _hoisted_25 = {
  class: "row",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_26 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_27 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_28 = { class: "menu-item" }
const _hoisted_29 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_31 = { class: "menu-title" }
const _hoisted_32 = { class: "menu-item" }
const _hoisted_33 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_35 = { class: "menu-title" }
const _hoisted_36 = { class: "menu-item" }
const _hoisted_37 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_39 = { class: "menu-title" }
const _hoisted_40 = { class: "menu-item" }
const _hoisted_41 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_43 = { class: "menu-title" }
const _hoisted_44 = { class: "menu-item" }
const _hoisted_45 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_47 = { class: "menu-title" }
const _hoisted_48 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_49 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_50 = { class: "menu-item" }
const _hoisted_51 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_53 = { class: "menu-title" }
const _hoisted_54 = { class: "menu-item" }
const _hoisted_55 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_57 = { class: "menu-title" }
const _hoisted_58 = { class: "menu-item" }
const _hoisted_59 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_61 = { class: "menu-title" }
const _hoisted_62 = { class: "menu-item" }
const _hoisted_63 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_65 = { class: "menu-title" }
const _hoisted_66 = { class: "menu-item" }
const _hoisted_67 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_69 = { class: "menu-title" }
const _hoisted_70 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_71 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_72 = { class: "menu-item" }
const _hoisted_73 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_75 = { class: "menu-title" }
const _hoisted_76 = { class: "menu-item" }
const _hoisted_77 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_79 = { class: "menu-title" }
const _hoisted_80 = { class: "menu-item" }
const _hoisted_81 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_83 = { class: "menu-title" }
const _hoisted_84 = { class: "menu-item" }
const _hoisted_85 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_87 = { class: "menu-title" }
const _hoisted_88 = { class: "menu-item" }
const _hoisted_89 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_91 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZGlobalFilter = _resolveComponent("VZGlobalFilter")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VZGlobalFilter),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : _createCommentVNode("", true),
                (_ctx.headerMenuIcons === 'svg')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen002.svg" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate("menu.components")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                  : (_ctx.headerMenuIcons === 'svg')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate("menu.documentation")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                  : (_ctx.headerMenuIcons === 'svg')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/coding/cod003.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate("menu.changelog")) + " v" + _toDisplayString(_ctx.version), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("a", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("a", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("a", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("a", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("a", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("a", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("a", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("a", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("a", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("a", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("a", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("a", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("a", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("a", _hoisted_85, [
                    _hoisted_86,
                    _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("a", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.translate("menu.exampleLink")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}